import { Component, Input, OnInit } from '@angular/core';
import { HelpService } from '../service/help.service';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'jhi-help-link',
    standalone: true,
    imports: [
        NgbTooltipModule,
        TranslateModule
    ],
    templateUrl: './help-link.component.html',
    styleUrl: './help-link.component.scss'
})
export class HelpLinkComponent implements OnInit {

    @Input() helpKey: string;
    @Input() helpTooltipKey: string;
    @Input() helpLink: string;

    constructor(private helpService: HelpService) {
    }

    ngOnInit(): void {
        if (this.helpKey && (!this.helpLink || !this.helpLink.length)) {
            this.helpService.getHelpLink(this.helpKey).toPromise().then((response) => {
                if (response.body) {
                    this.helpLink = response.body;
                }
            }).catch((error) => {
            });
        }
    }

}
